import s from './SingleUserView.module.scss';

export const UserCreateView = () => {
  return <div>hehe nope</div>;
};
